var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99996 5.83366V12.667M3.83329 5.50033H13.1666M4.99996 12.8337H12C12.7363 12.8337 13.3333 12.2367 13.3333 11.5003V4.50033C13.3333 3.76395 12.7363 3.16699 12 3.16699H4.99996C4.26358 3.16699 3.66663 3.76395 3.66663 4.50033V11.5003C3.66663 12.2367 4.26358 12.8337 4.99996 12.8337Z",
    stroke: "#9EC7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.401aebaa.svg";
export { ForwardRef as ReactComponent };